<template>
  <b-row>
    <b-col v-if="displayName" cols="12">
      <b-form-checkbox
        class="v3_control_checkbox my-2"
        :checked="true"
        :disabled="disabled"
        @change="handleUnselect"
      >
        {{ displayName }}
      </b-form-checkbox>
    </b-col>
    <b-col cols="12" class="d-flex justify-content-center my-2">
      <item-with-tooltip
        :name="`derived-location-filter-select`"
        :active="disabled"
        message="Filtering is disabled until the study is completed."
      >
        <b-button
          variant="v3_teal_outline"
          @click="isOpen = true"
          :disabled="isOpen || disabled"
        >
          {{ displayName ? 'Change Selection' : 'Select' }}
        </b-button>
      </item-with-tooltip>
    </b-col>
    <b-col
      v-if="isOpen"
      cols="12"
      class="d-flex align-items-center flex-column my-2"
    >
      <b-button variant="v2_main" @click="handleAddToFilters">
        Add to Filter
      </b-button>
      <location-selector-for-filter
        ref="locationSelector"
        :location-data="locationData"
        @set-location-data="handleLocationChange"
      />
    </b-col>
  </b-row>
</template>

<script>
import LocationSelectorForFilter from '@/components/survey/results/select-filters/LocationSelectorForFilter';
import ItemWithTooltip from '@/components/ui-elements/ItemWithTooltip';
import cloneDeep from 'lodash/cloneDeep';

export default {
  name: 'LocationFilter',
  props: {
    locationFilterData: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    LocationSelectorForFilter,
    ItemWithTooltip,
  },
  data: function () {
    return {
      isOpen: false,
      locationData: cloneDeep(this.locationFilterData),
    };
  },
  computed: {
    displayName: function () {
      return this.locationFilterData && this.locationFilterData.value
        ? this.locationFilterData.value.display_name
        : null;
    },
  },
  methods: {
    handleLocationChange: function (data) {
      this.locationData = data;
    },
    handleAddToFilters: function () {
      this.$refs.locationSelector.validate();
      if (!this.$refs.locationSelector.isInValid()) {
        this.$emit('set-location-filter', this.locationData);
        this.isOpen = false;
      }
    },
    handleUnselect: function () {
      this.$emit('clear-location-filter');
      this.isOpen = false;
    },
  },
};
</script>

<style scoped></style>
